import React, { Component } from 'react'
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './AutoPayout.css';
import cx from 'classnames';
import getPayoutList from './getPayoutList.graphql';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import AutoPayoutList from '../../../components/SiteAdmin/AutoPayout/AutoPayoutList';
import Loader from '../../../components/Common/Loader/Loader';

export class AutoPayout extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired
    }

    static defaultProps = {
        booking: {
            loading: true
        }
    }

    render() {
        const { title, getPayoutData, getPayoutData: { loading } } = this.props;
        return (
            <Loader type={"page"} show={loading}>
            <div className={s.root}>
                <div className={s.container}>
                   <div className={cx(s.heading, 'textAlignRightRTL')}>
                        {title}
                    </div>
                    <div className={s.paddingRoutesSection}>
                        <AutoPayoutList getPayoutData={getPayoutData} />
                    </div>
                </div>
            </div>
            </Loader>
        );
    }
}

export default compose(
    withStyles(s),
    graphql(getPayoutList, {
        name: 'getPayoutData',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only'
        }
    })
)(AutoPayout);
